/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowLeftUp: {
  name: 'arrow-left-up';
  data: string;
} = {
  name: 'arrow-left-up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.707 17.707a1 1 0 0 0 0-1.414L9.414 8H15a1 1 0 1 0 0-2H7a1 1 0 0 0-1 1v8a1 1 0 1 0 2 0V9.414l8.293 8.293a1 1 0 0 0 1.414 0Z" fill="currentColor"/></svg>`,
};
